import FileReader from '../Resources/ViewTypes/FileReader';
import PDFModalWrapper from './style/PDFModalWrapper';

const PDFModal = ({ params: { resource, type } }) => (
  <PDFModalWrapper>
    <FileReader type={type} resource={resource} />
  </PDFModalWrapper>
);

export default PDFModal;
